// This id is required to ensure pollinator tests work between Nav3 and Nav4 and also in feature tests
export const GLOBAL_CREATE_BUTTON_NAV4 = 'atlassian-navigation--create-button';
